<div class="relative">

    <form [formGroup]="schedulerForm" (ngSubmit)="scheduleEvent()">

        <div class="flex gap-1">

            <div>
                <input formControlName="session_type" type="radio" class="custom-toggle" hidden value="classroom"
                    id="classroom">
                <label for="classroom" class="capitalize">classroom session</label>
            </div>

            <div>
                <input formControlName="session_type" type="radio" class="custom-toggle" hidden value="external"
                    id="external">
                <label for="external" class="capitalize">external session</label>
            </div>

        </div>

        <div class="mt-5 border-b">
            @if(schedulerForm.get('session_type')?.value === 'classroom')
            {
            <select class="select w-full text-xl border border-b" formControlName="course_id">
                <option disabled selected value="null">Select Course</option>
                @for (c of (courses$ | async)?.data || []; track $index) {
                <option [value]="c.id">{{c.course_name}}</option>
                }
            </select>
            @if (schedulerForm.get('course_id')?.touched &&
     schedulerForm.get('course_id')?.errors?.['required']) {
    <div class="mt-1 text-xs text-red-600">
        Course is required.
    </div>
}
            }@else{
            @if(schedulerForm.get('session_type')?.value === 'external') {

<label class="input input-ghost flex items-center gap-2">
    <span class="text-zinc-400">Title</span>
    <input type="text"
           class="grow text-lg"
           formControlName="session_title" />
</label>



}
            }
        </div>

        <div class=" mt-3 ">
            <div class="flex gap-5">
                <i class="ri-time-line font-medium text-lg"></i>



                <div formGroupName="scheduleTime" class="w-full flex flex-col gap-3">


                    <div class="flex flex-col gap-3  w-full">
                        <div class="flex items-center gap-3">

                            <div class="input-date w-full">
                                <label class="form-control col-span-1 w-full ">
                                    <input formControlName="start_date" type="date" placeholder="Start date" #dobInput
                                        (focus)="dobInput.click()" class="input input-sm input-bordered w-full " />
                                </label>
                                @if (schedulerForm.get('scheduleTime.start_date')?.touched && schedulerForm.get('scheduleTime.start_date')?.errors?.['required']) {
                                <div class="mt-1 text-xs text-red-600">Start date is required.</div>
                                }
                                @if (schedulerForm.get('scheduleTime.start_date')?.touched && schedulerForm.get('scheduleTime.start_date')?.errors?.['pastDate']) {
                                <div class="mt-1 text-xs text-red-600">Start date cannot be in the past.</div>
                                }

                            </div>

                            <!-- <i class="ri-subtract-fill font-semibold"></i>
                        <div class="input-date w-full">
                            <label class="form-control col-span-1 w-full ">
                                <input type="date" placeholder="" #dobInput (focus)="dobInput.click()"
                                    class="input input-sm input-bordered w-full " />
                            </label>
                        </div> -->


                        </div>

                        <div class="flex gap-3 items-center">

                            <div>
                                <select formControlName="start_time" class="select select-sm select-bordered w-full"
                                (change)="onFromTimeChange($event)">
                                <option value="" disabled>Start Time</option>
                                @for (i of alltimeOptions || []; track $index) {
                                <option [value]="i">{{i}}</option>
                                }
                            </select>
                            @if (schedulerForm.get('scheduleTime.start_time')?.touched && schedulerForm.get('scheduleTime.start_time')?.errors?.['required']) {
                            <div class="mt-1 text-xs text-red-600">Start time is required.</div>
                            }
                            @if (schedulerForm.get('scheduleTime.start_time')?.touched && schedulerForm.get('scheduleTime.start_time')?.errors?.['pastStartTime']) {
                            <div class="mt-1 text-xs text-red-600">Start time cannot be in the past.</div>
                            }
                            @if (schedulerForm.get('scheduleTime.start_time')?.touched && schedulerForm.get('scheduleTime.start_time')?.errors?.['invalidTimeRange']) {
                            <div class="mt-1 text-xs text-red-600">End time must be after start time.</div>
                            }

                            </div>
                            <i class="ri-subtract-fill font-semibold"></i>
                            <div>
                                <select formControlName="end_time" class="select select-sm select-bordered w-full">
                                <option value="" disabled>End Time</option>
                                @for (i of totimeOptions || []; track $index) {
                                <option [value]="i">{{i}}</option>
                                }
                            </select>
                            @if (schedulerForm.get('scheduleTime.end_time')?.touched && schedulerForm.get('scheduleTime.end_time')?.errors?.['required']) {
                            <div class="mt-1 text-xs text-red-600">End time is required.</div>
                            }
                            @if (schedulerForm.get('scheduleTime.end_time')?.touched && schedulerForm.get('scheduleTime.end_time')?.errors?.['pastEndTime']) {
                            <div class="mt-1 text-xs text-red-600">End time cannot be in the past.</div>
                            }
                            @if (schedulerForm.get('scheduleTime.end_time')?.touched && schedulerForm.get('scheduleTime.end_time')?.errors?.['invalidTimeRange']) {
                            <div class="mt-1 text-xs text-red-600">End time must be after start time.</div>
                            }

                            </div>
                        </div>

                    </div>


                    <select formControlName="recurrence_type" class="select select-sm select-bordered w-full">
                        <option value="null">Do not Repeat</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                    </select>


                    <div>
                        <!-- <label class="label underline">Custome Options</label> -->

                        <!-- <div>
                            <span class="text-sm">Repeat Every</span>
                            <div class="flex items-center gap-3 mt-2">
                                <input type="number" class="input input-sm input-bordered w-28">
                                <select class="select select-sm select-bordered w-full">
                                    <option>Day</option>
                                    <option>Weekly</option>
                                    <option>Monthly</option>
                                    <option>yearly</option>
                                </select>
                            </div>
                        </div> -->

                        @if (schedulerForm.get('scheduleTime.recurrence_type')?.value === 'weekly') {
                        <div class="mt-3">
                            <span class="text-sm underline text-zinc-500">Repeat On</span>
                            <div class="flex items-center gap-1 mt-2">

                                @for (day of weekDays; track $index) {
                                <div>
                                    <input (change)="onRepeatChange($event, day.initials)" id="{{day.name}}" hidden
                                        class="custom-toggle" type="checkbox" name="repeat_on" value="{{day.initials}}"
                                        [checked]="isRepeatDaySelected(day.initials)">
                                    <label for="{{day.name}}" class="circle">{{day.initials}}</label>
                                </div>
                                }

                            </div>
                        </div>
                        }

                        @if (schedulerForm.get('scheduleTime.recurrence_type')?.value === 'daily') {
                        <div class="mt-3">
                            <span class="text-sm underline text-zinc-500">End By</span>

                            <!-- Validation message is shown when repeat end date is before the schedule date. -->
                            <div class="input-date w-full mt-1">
                                <label class="form-control col-span-1 w-full ">
                                    <input type="date" formControlName="end_date" placeholder="End Date" #dobInput
                                        (focus)="dobInput.click()" class="input input-sm input-bordered w-full " />
                                </label>
                                @if (schedulerForm.get('scheduleTime.end_date')?.errors?.['endDateMin']) {
                                <div class="mt-1 text-xs text-red-600">End By date field must be a date after or equal to Start date.</div>
                                } 

                            </div>
                            <!-- <div>
                                <div class="flex items-center ">
                                    <input type="radio" id="never" name="end_by" class="radio radio-sm" />
                                    <label for="never" class="label">Never</label>
                                </div>
                                <div class="flex gap-10 items-center">
                                    <div class="flex items-center ">
                                        <input type="radio" id="end_on" name="end_by" class="radio radio-sm" />
                                        <label for="end_on" class="label">On</label>
                                    </div>
                                    <div class="input-date w-32">
                                        <label class="form-control col-span-1 w-full ">
                                            <input type="date" placeholder="" #dobInput (focus)="dobInput.click()"
                                                class="input input-sm input-bordered w-full " />
                                        </label>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                        }
                    </div>



                </div>

            </div>


            <hr class="my-3">

            @if (schedulerForm.get('session_type')?.value === 'external') {

            <div class="flex gap-5">
                <i class="ri-link text-sm font-semibold"></i>

                <div class="w-full">
                    <div class="flex justify-between items-center">

                        <p class="text-sm font-semibold">Add Meeting</p>
                        <div class="flex gap-2 ">
                            <div>
                                <input formControlName="add_meet" type="radio" value="true" class="custom-toggle" hidden
                                    id="yes">
                                <label for="yes">Yes</label>
                            </div>
                            <div>
                                <input formControlName="add_meet" type="radio" value="false" class="custom-toggle"
                                    hidden id="no">
                                <label for="no">No</label>
                            </div>
                        </div>

                    </div>
                    @if (schedulerForm.get('add_meet')?.value === 'true') {
                    <div class="mt-4">
                        <input
    type="text"
    formControlName="add_meet_link"
    class="input input-bordered w-full"
    placeholder="Meeting Link">


@if (
    schedulerForm.get('add_meet_link')?.touched &&
    schedulerForm.get('add_meet_link')?.errors?.['pattern']
) {
<div class="mt-1 text-xs text-red-600">
    Please enter a valid URL.
</div>
}
                    </div>
                    
                    }

                    <div>

                    </div>
                </div>

            </div>
            }


            <hr class="my-3">
            <div class="flex gap-5 ">
                <i class="ri-user-add-line font-semibold"></i>
                <div class="w-full">
                    <p class="text-sm font-semibold">Teacher</p>


                    <div class="dropdown dropdown-end mt-1 w-full max-w-sm">
                        <input type="text" placeholder="Search" class="input input-bordered  w-full"
                            (input)="onUserSearch($event)">
                        <div tabindex="0"
                            class="dropdown-content menu bg-base-100 rounded-box z-[1] w-full p-2 mt-2 grid grid-cols-1 min-h-[7rem] max-h-[15rem] overflow-y-auto border shadow-xl">

                            @if (users && users.length > 0) {
                            @for (i of users; track $index) {
                            @if(!isUserSelected(i.email)) {
                            <button type="button" class="p-3 rounded-md cursor-pointer hover:bg-zinc-100 text-start"
                                (click)="onSelectUser(i)">
                                <p class="font-semibold">{{i.name}}</p>
                                <Span class="text-xs font-normal capitalize text-zinc-500">Role:
                                    {{i?.role?.name}}</Span>
                            </button>
                         
                            }
                            }
                            }@else {
                            <div class="p-3 rounded-md text-center">
                                <p class="text-zinc-500 font-mono italic">Loading...</p>
                            </div>
                            }


                        </div>
                           @if (selectedUsers.length === 0 && schedulerForm.get('attendees')?.touched) {
    <div class="mt-1 text-xs text-red-600">
        Please select at least one teacher.
    </div>
}
                    </div>



                    <div class="mt-2">

                        <div class="flex gap-2 flex-wrap mt-5">
                            @for (i of selectedUsers; track $index) {
                            <button type="button"
                                class="btn btn-sm rounded-full items-center capitalize bg-white border"
                                (click)="removeUser($index)"><span class="flex items-center gap-0.5"><i
                                        class="ri-user-6-line text-base text-blue-600"></i>{{i.name}}</span> <i
                                    class="ri-close-line "></i></button>
                            }
                        </div>

                    </div>
                </div>

            </div>

            <hr class="my-3">
            <div class="flex gap-5">
                <i class="ri-align-justify font-semibold"></i>
                <div class="w-full">
                    <p class="text-sm font-semibold">Description</p>
                    <textarea formControlName="description" class="textarea textarea-bordered textarea-sm w-full mt-2"
                        rows="5" id=""></textarea>
                    <div class="mt-1 flex justify-between text-xs text-zinc-500">
                        <span>Max 250 characters.</span>
                        <span>{{(schedulerForm.get('description')?.value?.length || 0)}}/250</span>
                    </div>
                    @if (schedulerForm.get('description')?.touched && schedulerForm.get('description')?.errors?.['maxlength']) {
                    <div class="mt-1 text-xs text-red-600">Description must be 250 characters or fewer.</div>
                    }
                </div>
            </div>

            <hr class="my-3">
            <div class="flex gap-5 ">
                <i class="ri-graduation-cap-line font-semibold"></i>
                <div class="w-full">
                    <p class="text-sm font-semibold">Add Class</p>

                    <div class="dropdown dropdown-top mt-1 w-full ">
                        <input (input)="searchAcademicEntity($event)" type="text" class="input  input-bordered w-full">

                        <div tabindex="0"
                            class="dropdown-content mb-2 border shadow-lg menu bg-base-100 rounded-box z-[1] w-full text-xs font-semibold p-2  ">
                            <div class="grid grid-cols-1 gap-2 max-h-60 overflow-y-auto">

                                @for (d of academicEntity || []; track $index) {
                                <div>
                                    <div class="flex items-center gap-2 font-semibold text-zinc-600 mt-2">
                                        <button [disabled]="d.classes?.length == 0" type="button"
                                            class="btn btn-xs btn-square"
                                            (click)="toggleAcademicAccordion(d.id,'department')"><i
                                                class="ri-arrow-down-s-line"></i></button>
                                        <input type="checkbox" class="checkbox checkbox-sm"
                                            [checked]="isDepartmentSelected(d)"
                                            (change)="toggleSelection('department', d, null, null, $event)" />
                                        <span>{{d.department_name}}</span>
                                    </div>
                                    @if (AcademicAccordion.department_id == d.id) {
                                    <div class="grid grid-cols-1 gap-2 max-h-60  pl-10 mt-2">
                                        @for (c of d.classes || []; track $index) {
                                        <div>
                                            <div class="flex items-center gap-2 font-semibold text-zinc-600 mt-2">
                                                <button type="button" class="btn btn-xs btn-square"
                                                    [disabled]="c.batches?.length == 0"
                                                    (click)="toggleAcademicAccordion(c.id,'class')"><i
                                                        class="ri-arrow-down-s-line"></i></button>
                                                <input type="checkbox" class="checkbox checkbox-sm"
                                                    [checked]="isClassSelected(c)"
                                                    (change)="toggleSelection('class', d, c, null, $event)" />
                                                <span>{{c.class_name}}</span>
                                            </div>
                                            @if (AcademicAccordion.class_id == c.id) {
                                            <div class="grid grid-cols-1 gap-2 max-h-60  pl-10 mt-2">
                                                @for (b of c.batches || []; track $index) {
                                                <div>
                                                    <div
                                                        class="flex items-center gap-2 font-semibold text-zinc-600 mt-2">
                                                        <input type="checkbox" class="checkbox checkbox-sm"
                                                            [checked]="isBatchSelected(b)"
                                                            (change)="toggleSelection('batch', d, c, b, $event)" />
                                                        <span>{{b.batch_name}}</span>
                                                    </div>


                                                </div>
                                                }
                                            </div>
                                            }

                                        </div>
                                        }
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                            
                        </div>
                    </div>


                    @if (selectedAcademicPreview.length > 0) {
                    <div class="flex flex-wrap gap-2 mt-2">
                        @for (item of selectedAcademicPreview; track $index) {
                        <div
                            class="inline-flex items-center gap-1 rounded-full border bg-white px-2.5 py-1 text-xs text-zinc-700">
                            <i
                                [class]="item.type === 'department' ? 'ri-building-line text-blue-600' : item.type === 'batch' ? 'ri-group-line text-blue-600' : 'ri-graduation-cap-line text-blue-600'"></i>
                            <span class="font-medium">{{item.type === 'batch' ? item.parent : item.label}}</span>
                            @if (item.type === 'batch') {
                            <span class="text-zinc-400">/</span>
                            <span>{{item.label}}</span>
                            }
                        </div>
                        }
                    </div>
                    }

@if (selectedAcademicPreview.length === 0 && schedulerForm.get('department_id')?.touched) {
    <div class="mt-1 text-xs text-red-600">
        Please select at least one class.
    </div>
}
                    <div
                        class=" flex gap-2 text-xs text-zinc-500 mt-2 bg-zinc-50 border-e-zinc-200 border p-1.5 rounded">
                        <span class="font-semibold text-nowrap"><i class="ri-information-line"></i></span>
                        <span><b>Note : </b>The invite will be sent to all participants belonging to these
                            classes</span>
                    </div>
                </div>

            </div>

            <hr class="my-3">
            <div class="flex gap-5 ">
                <i class="ri-function-add-line font-semibold"></i>
                <div class="w-full">
                    <p class="text-sm font-semibold">Additional Parameters</p>
                    <label class="input input-bordered flex items-center gap-2 w-full mt-2">
                        <input #additionalParamsInput type="text" class="grow" placeholder="Daisy" />
                        <button type="button" class="btn btn-circle btn-sm"
                            (click)="updateAdditionalParamsList('add',additionalParamsInput.value)"><i
                                class="ri-add-line"></i></button>
                    </label>
                    <div class="flex flex-wrap gap-2 mt-2">
                        @for (i of AdditionalParamsArray.controls; track $index) {
                        <button type="button" (click)="updateAdditionalParamsList('remove','', $index)"
                            class="btn btn-xs">{{i.value}}<i class="ri-close-line"></i></button>
                        }
                    </div>
                    @if (AdditionalParamsArray.length === 0 && schedulerForm.get('additional_params')?.touched) {
    <div class="mt-1 text-xs text-red-600">
        At least one additional parameter is required.
    </div>
}
                </div>

            </div>

        </div>

        <div class="bg-white border-t py-3 flex justify-end items-center mt-5 gap-2 sticky bottom-0">
            <button type="submit" class="btn btn-sm rounded-full btn-primary">Save</button>
        </div>
    </form>

</div>

<!-- TODO:: teacher single select -->
